
import LiveChats from './live_chats'
import Chat from './chat'
import live_chats from './live_chats_reducer'

export { LiveChats, Chat, live_chats }
export default LiveChats 


// WEBPACK FOOTER //
// ./src/components/chats/index.js